class ProductGallerySlider {
  constructor() {
    this.productGallery = document.querySelector('.product-img-thumb');
    this.init();
  }

  init() {
    if (this.productGallery) {
      this.productGalleryImg = document.querySelector('.product-gallery-main-img > img');
      this.slidesWrapper = this.productGallery.querySelector('.product-img-thumb-wrapper');
      this.slidesWrapperInner = this.productGallery.querySelector('.product-img-thumb-wrapper-inner');
      this.slides = Array.from(this.slidesWrapper.querySelectorAll('.product-img-thumb-slide'));
      this.slideTotalWidth =
        parseInt(this.slides[0].offsetWidth) +
        parseFloat(window.getComputedStyle(this.slides[0]).marginRight);
      this.btnPrev = this.productGallery.querySelector('.product-img-thumb-prev');
      this.btnNext = this.productGallery.querySelector('.product-img-thumb-next');

      this.bindClicks();

      this.updateActiveSlide(this.productGallery.querySelector('.product-img-thumb-slide'));
      window.onresize = this.doSlide.bind(this);
    }
  }

  bindClicks() {
    let currentInstance = this,
      activeSlideIndex = null;

    this.btnPrev.addEventListener('click', function () {
      activeSlideIndex = currentInstance.slides.indexOf(currentInstance.activeSlide);

      if (activeSlideIndex > 0) {
        currentInstance.updateActiveSlide(currentInstance.slides[--activeSlideIndex]);
      }
    });

    this.btnNext.addEventListener('click', function () {
      activeSlideIndex = currentInstance.slides.indexOf(currentInstance.activeSlide);

      if (activeSlideIndex < currentInstance.slides.length - 1) {
        currentInstance.updateActiveSlide(currentInstance.slides[++activeSlideIndex]);
      }
    });

    currentInstance.slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        if (this !== currentInstance.activeSlide) {
          currentInstance.updateActiveSlide(this);
        }
      });
    });
  }

  updateActiveSlide(slide) {
    if (this.activeSlide) {
      this.activeSlide.classList.remove('product-img-thumb-slide-active');
    }

    this.activeSlide = slide;
    this.activeSlide.classList.add('product-img-thumb-slide-active');

    this.productGalleryImg.setAttribute('src', this.activeSlide.querySelector('img').dataset.bigSrc);
    this.productGalleryImg.setAttribute('alt', this.activeSlide.querySelector('img').dataset.bigAlt);

    this.doSlide();

    if (this.slides.indexOf(this.activeSlide) === 0) {
      this.btnPrev.classList.add('swiper-button-disabled');
    } else {
      this.btnPrev.classList.remove('swiper-button-disabled');
    }

    if (this.slides.indexOf(this.activeSlide) === this.slides.length - 1) {
      this.btnNext.classList.add('swiper-button-disabled');
    } else {
      this.btnNext.classList.remove('swiper-button-disabled');
    }
  }

  doSlide() {
    let wrapperRect = this.slidesWrapper.getBoundingClientRect(),
      slideRect = this.activeSlide.getBoundingClientRect();

    if (
      wrapperRect.left > slideRect.left ||
      wrapperRect.left + wrapperRect.width < slideRect.left + slideRect.width
    ) {
      let translate = parseInt(this.slidesWrapperInner.style.transform.replace(/[^0-9]/g, ''));

      if (isNaN(translate)) {
        translate = 0;
      }

      if (wrapperRect.left > slideRect.left) {
        translate -= this.slideTotalWidth;
      } else {
        translate += this.slideTotalWidth;
      }
      translate *= -1;

      this.slidesWrapperInner.style.transform = `translateX(${translate}px)`;
    }
  }
}

export default ProductGallerySlider;